import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(VImg, _vm._b({
    on: {
      "click": function ($event) {
        return _setup.emit('click');
      },
      "mouseenter": function ($event) {
        return _setup.emit('mouse-enter');
      },
      "mouseleave": function ($event) {
        return _setup.emit('mouse-leave');
      }
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function () {
        return [_c(VProgressLinear, {
          attrs: {
            "indeterminate": "",
            "rounded": "",
            "height": "2"
          }
        })];
      },
      proxy: true
    }])
  }, 'v-img', _setup.imageBinding, false));
};
var staticRenderFns = [];
export { render, staticRenderFns };